import { restClient } from '@/Core'

import type { CrmDocumentGenerationConfig, GenerationDocumentType } from '../GenerateDocument'

type CollectionResponse = { items?: unknown[]; 'hydra:member'?: unknown[] } | unknown[] | null

/** Типів документа в тенанті одиниці; із запасом — одним запитом. */
const LIMIT = 100

/**
 * Типи документа для меню «Генерація документу» (`SPEC-012` §9.2, P-12):
 * лише свого провайдера (N-19 — у легасі в меню потрапляв тип із чужим
 * провайдером і завжди падав) з увімкненим «Використовувати в картці …»,
 * за сортуванням. Видалені ховає бек. Тип без шаблону в меню лишається:
 * генерація з нього відповість зрозумілою причиною (P-08).
 */
export const LoadDocumentTypesTask = async (config: CrmDocumentGenerationConfig): Promise<GenerationDocumentType[]> => {
    const filters = JSON.stringify({
        and: [
            { field: 'provider', op: '=', value: config.provider },
            { field: config.useInFlag, op: '=', value: true },
        ],
    })

    const raw = await restClient.get(
        `/services/document_types?limit=${LIMIT}&sort[sorting]=ASC&filters=${encodeURIComponent(filters)}`
    )
    const data = raw as unknown as CollectionResponse
    const items = Array.isArray(data) ? data : (data?.items ?? data?.['hydra:member'] ?? [])

    return (Array.isArray(items) ? items : []).flatMap((item): GenerationDocumentType[] => {
        const record = (item ?? {}) as Record<string, unknown>
        const uuid = record['uuid']
        const title = record['title']

        return typeof uuid === 'string' && uuid !== '' && typeof title === 'string' ? [{ uuid, title }] : []
    })
}
